import Constant from '@/const';
import axios from 'axios';

const getRegion = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/region/province?search='),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getRegion;
